import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import { KopkarTable, SelectColumnFilter } from '../../components/KopkarTable';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import { baseAPI } from '../../services/baseAPI';
import { Users } from 'react-feather';

function DataPinjamanTunai() {

  //Roles
  const USP = 3;
  const BENDAHARA = 5;
  const token = useUserStore((state) => state.token);
  const users = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const [dataPengajuan, setDataPengajuan] = useState([]);

  // CONTROLLER & LOAD DATA
  const fetchDataPengajuan = async (role) => {

    await baseAPI
      .get(`/v1/ajuanpinjam`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const data = res.data.data.ajuansetuju;
        setDataPengajuan(data);
        setIsLoading(false)
      })
      .catch((error) => {
        setIsLoading(false);
        console.log(`error ${error}`);
      })
  };

  const deleteAjuan = async (id) => {
  Swal.fire({
    title: 'Apakah anda akan menghapus data ini?',
    text: "You won't be able to revert this!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, delete it!'
  }).then(async (result) => {
    if (result.isConfirmed) {
      setIsLoading(true);
      await baseAPI
        .delete(`/v1/ajuanpinjam/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          Swal.fire({
            icon: 'success',
            title: 'Pinjaman data has been deleted',
            showConfirmButton: false,
            timer: 1500
          })
        })
        .catch((error) => {
          setIsLoading(false);
          Swal.fire({
            icon: 'error',
            title: 'Delete data is failed',
            showConfirmButton: false,
            timer: 1500
          })
          console.log(`error ${error}`)
        })
        .finally(() => {
          fetchDataPengajuan();
          setIsLoading(false);
        });
    }
  });
  }

  useEffect(() => {
    setIsLoading(true);
    if (users.role === USP || users.role === BENDAHARA) {
      fetchDataPengajuan(users.role);
    }
  }, [token]);

  const contentTableAction = (id, iduser, status, cicilanke) => {
    if (id && iduser !== null) {
      return (
        <div className='text-center'>
          <Link 
            to={`/pinjamtunai/datapinjamantunai/editpinjamtunai/${id}/${iduser}`} 
            className="badge badge-primary"
            style={{ backgroundColor: "#6A9C89", marginRight: 10 }}
          >
            <Icon name="Edit" size={16} />
          </Link>
          <button 
            hidden={status !== "Disetujui" && cicilanke == 0 ? false : true}
            className="badge bg-danger"
            onClick={() => deleteAjuan(id)}
          >
            <Icon name="Trash" size={16} />
          </button>
        </div>
      )
    }
  };
  
  const dataPinjamListView = () => {
    const columns = [
      {
        Header: 'No',
        id: 'row',
        width: '2%',
        accessor: 'no',
        sortType: 'basic',
        disableFilters: true,
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.index + 1}</div>,
      },
      {
        Header: 'Nomor Pinjaman',
        id: 'nopinjam',
        width: '5%',
        accessor: 'nopinjam',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-left'>{cellInfo.row.original.notrxdetailpinjam}</div>
      },
      {
        Header: 'ID Kopkar',
        id: 'idkopkar',
        width: '6%',
        accessor: 'idkopkar',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.idkopkar}</div>
      },
      {
        Header: 'Nama',
        id: 'nama',
        width: '12%',
        accessor: 'nama',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.name_anggota}</div>
      },
      {
        Header: 'NPP',
        id: 'npp',
        width: '8%',
        accessor: 'npp',
        sortType: 'basic',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.npp_anggota}</div>
      },
      {
        Header: 'Plafond',
        id: 'plafond',
        width: '8%',
        // accessor: 'plafond',
        // sortType: 'basic',
        // filter: 'includes',
        // Filter: SelectColumnFilter,
        Cell: (cellInfo) => <div className='text-left'>Rp.{parseFloat(cellInfo.row.original.plafond).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Cicilan Pokok',
        id: 'cpokok',
        width: '8%',
        Cell: (cellInfo) => <div className='text-center'>Rp.{parseFloat(cellInfo.row.original.cpokok).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Jasa Bulan',
        id: 'jasa',
        width: '8%',
        Cell: (cellInfo) => <div className='text-center'>Rp.{parseFloat(cellInfo.row.original.jasa_bulan).toLocaleString('id-ID')}</div>
      },
      {
        Header: 'Tanggal Pinjam', // tanggal approved final
        id: 'tglpinjam',
        width: '8%',
        Cell: (cellInfo) => <div className='text-center'>{moment(cellInfo.row.original.trxdetailpinjam).format("DD/MM/yyyy")}</div>
      },
      {
        Header: 'Cicilan Ke',
        id: 'cicilanke',
        width: '8%',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.cicilan_ke} dari {cellInfo.row.original.lama}</div>
      },
      {
        Header: 'Status',
        id: 'status',
        width: '5%',
        accessor: 'status',
        sortType: 'basic',
        filter: 'includes',
        Cell: (cellInfo) => <div className='text-center'>{cellInfo.row.original.status}</div>
      },
      {
        Header: 'Action',
        id: 'action',
        width: '8%',
        Cell: (cellInfo) =>
          contentTableAction(
            cellInfo.row.original.id,
            cellInfo.row.original.id_users,
            cellInfo.row.original.status,
            cellInfo.row.original.cicilan_ke
          )
      }
    ];

    return (
      <>
        {/* Main card */}
        <div className='row row-deck row-cards'>
          <div className="col-md-12">
            <Card styleBody={{ padding: 0, paddingTop: 20 }}>
              <KopkarTable
                title="Ajuan Pinjaman"
                columns={columns}
                data={dataPengajuan}
                formOne={null}
                formTwo={null}
                formThree={null}
                rowSize={[50, 100, 150]}
              />
            </Card>
          </div>

        </div>
      </>
    )
  };

  // VIEW
  const headerView = () => (
    <>
      <div className='page-header'>
        <div className='row align-items-center'>
          {/* Title */}
          <div className='col'>
            <ol className='breadcrumb'>
              <li className='breadcrumb-item Navbar_title'>
                <Link to='#' style={{ color: '#333' }}>Pinjaman Tunai</Link> /{' '}
                <Link to='/pinjamtunai/datapinjamantunai' style={{ color: '#333' }}>Data Pinjaman Tunai</Link>
              </li>
            </ol>
          </div>

          {/* Download Report Data */}
          {/* <div className='col-auto ml-auto d-print-none'>
            <Link to="/employee/reportemployee">
              <button
                type="button"
                className="btn btn-gray"
                style={{ marginLeft: 10 }}
                onClick={() => console.log('download data pinjaman')}
              >
                <div className="d-flex align-items-center">
                  <Icon name="Download" size={16} style={{ marginRight: 5 }} />{' '}
                  <span>Download Pinjaman Tunai</span>
                </div>
              </button>
            </Link>
          </div> */}

        </div>
      </div>
    </>
  );
    
   return (
    <div className='container-fluid'>

      {headerView()}

      {/* main content */}
      {isLoading ? <LoadingView /> : dataPinjamListView()}

    </div>

  );

}

export default DataPinjamanTunai;